export const environment = {
	app: 'C4',
	production: true,
	firebase: {
		apiKey: 'AIzaSyAcHHeavmanzoIv4jdJq6dZOYBOAcAWY8U',
		authDomain: 'c4-notifications.firebaseapp.com',
		databaseURL: 'https://c4-notifications.firebaseio.com',
		projectId: 'c4-notifications',
		storageBucket: 'c4-notifications.appspot.com',
		messagingSenderId: '24377137300',
		appId: '1:24377137300:web:73a00c0aab8531e79afc81',
	},
	apiBaseUrl: 'https://c4-backend.cargochief.com',
	SEGMENT_KEY: 'HbSSxDHje59i0IbwrWo26U1k0VsPFEco',
	redux: {
		sessionUpdateMinutes: 5,
	},
	webSocket: {
		reconnectTimeIntervalSeconds: 10,
		endpoint: 'wss://ws.cargochief.com',
		debugMode: false,
		enabled: true,
		sessionUpdateMinutes: 5,
	},
	GOOGLE_API_KEY: 'AIzaSyDDQ0PtQxFZQFP6pAopi86IbTfMjDXEnkM',
	environment: 'prod',
	TRUCK_SEARCH_COUNTRY: ['us', 'ca', 'mx'],
	BULK_MATCH_CONFIG: {
		load: {
			bucketName: 'cargochief-bulk-capacity-match',
		},
		project: {
			bucketName: 'cargochief-bulk-project',
		},
		priceLane: {
			bucketName: 'lanemaster-price-lanes-prod',
		},
		broker: {
			bucketName: 'cargochief-bulk-broker',
		},
	},
	PRICING_DATA_CONFIG: {
		bucketName: 'mcleod-loads-prod',
	},
	LANE_MASTER_BASE_URL: 'https://app.lanemaster.com',
	NO_OF_SEARCH_RESULTS_TO_DISPLAY: 200,
	CAPACITY_SEARCH_THRESHOLD: 25,
	MILES_PER_DAY: 650,
	STRIPE_PUBLISHABLE_KEY: 'pk_live_tIhH0U6y4AuAdiYCtM2tIDCk',
	CARRIER_TRAILER_TYPE: true,
	INTERCOM_APP_ID: 'agws3dki',
	PROJECT_FEATURES: {
		PROBABILITY: true,
		CADENCE: false,
	},
	RECENT_TRANSACTION_AGE: 90,
	SHOW_DEADHEAD_MSG: true,
	PRICING_FEEDBACK_LIMIT: 5,
	CARRIER_LANES_VIEW: true,
	PRICE_LANES_BUTTON_ENABLED: true,
	CUSTOMERS_VIEW: true,
	SCORECARDS: true,
	SCORECARDS_PAGE_SIZE: 50,
	CARRIER_RATES: true,
	INTEGRATIONS: true,
	RFP_PREVIEW_TABLE_ROWS_LIMIT: 5,
	RFP_LANES_LIMIT: 500,
	SCORECARD_ACTIONS: true,
	PAYMENT_TRANSIT_DAYS: 2,
	SHOW_CARRIER_UPLOAD_TO_USER: true,
	SHOW_NOTIFICATIONS: true,
	ACTIVE_INTEGRATIONS: [
		'MY_CARRIER_PACKETS',
		'BLUE_YONDER',
		'MCLEOD',
		'TAI',
		'OMNIS',
		'THREE_PL_SYSTEMS',
		'FMS',
		'LOGISTICALLY',
		'ALJEX',
		'TURVO',
		'BROKER_PRO',
		'RMIS',
		'GREEN_SCREENS'
	],
	MCLEOD_WEBHOOK: 'https://mcleod.cargochief.com/webhook',
	MERCURY_GATE_WEBHOOK: 'https://mercurygate.cargochief.com',
	TAI_WEBHOOK: 'https://tai.cargochief.com',
	OMNIS_WEBHOOK: 'https://omnis.cargochief.com',
	THREE_PL_SYSTEMS_WEBHOOK: 'https://3pl-systems.cargochief.com',
	FMS_WEBHOOK: 'https://fms.cargochief.com',
	LOGISTICALLY_WEBHOOK: 'https://logistically.cargochief.com',
	TURVO_WEBHOOK: 'https://turvo.cargochief.com',
	BROKER_PRO_WEBHOOK: 'https://broker-pro.cargochief.com',
	FREE_TRIAL_DAYS: 7,
	clientUrl: 'https://c4.cargochief.com/#/',
	MINIMUM_SEATS: 2,
	PROJECTS_BOARD: true,
	CARRIER_BIDDING: false,
	STRONG_LANES: false,
	TEAMS_CAPACITY: true,
	EMAIL_TEMPLATES: true,
	SEGMENT_PROXY: 'https://c4-seg-an.cargochief.com',
	EXCLUDE_BULK_CARRIER: true,
	CONFIDENCE_SCORE: true,
	rfp_pricing_loads_base_url: 'https://c4-accounts-prod.s3.us-west-1.amazonaws.com/',
	MINIMUM_MILES_PER_DAY: 300,
	V2_CARRIER_NETWORK_PAGE: false,
	V2_LOADS_PAGE: false,
	AUTOMATION_TOOLS_ENABLED: true,
	BA_BOOK_NOW_ENABLED: true,
	PRIVATE_FLEETS_ENABLED: false,
	AUTHORIZED_API_CLIENTS_ENABLED: true,
	PRICING_INTEGRATION_ENABLED: true,
	AMAZON_DEVELOPER_APP_ID: '',
	AMAZON_FREIGHT_INTEGRATIONS_URL: '',
	LOGO_CONFIG: {
		bucketName: 'account-logo-prod',
	},
	LOADS_SOURCING_PAGE: true,
	TABLEAU_DASHBOARD_URL:
		'https://us-west-2b.online.tableau.com/t/cargochief/views/DFMDashboard_V2/ExecutiveDashboard/f64fa2a4-8cb5-4ecb-bc2d-cb6ca467554b/797024fd-e133-4e97-8ad8-c3ac7311e1ba',
	TABLEAU_CUSTOMER_REPORT_URL: `https://us-west-2b.online.tableau.com/t/cargochief/views/Customer_DFMDashboard/ExecutiveDashboard`,
	ENABLE_ENGAGED_TAB_ON_PROJECT_DETAILS: true,
	PROJECT_GROUPS_ENABLED: true,
	VALIDATE_MC_DOT: true,
	LOAD_OFFER_BATCH_TEMPLATE_ENABLED: true,
};
